var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",style:(("height: " + _vm.height + "px"))},[_c('b-spinner',{attrs:{"type":"grow","label":"Spinning","variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }